import { render, staticRenderFns } from "./CustomerInformation.vue?vue&type=template&id=38f9d80c&scoped=true"
import script from "./CustomerInformation.vue?vue&type=script&lang=js"
export * from "./CustomerInformation.vue?vue&type=script&lang=js"
import style0 from "./CustomerInformation.vue?vue&type=style&index=0&id=38f9d80c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f9d80c",
  null
  
)

export default component.exports